import browserFastApiClient from "@/core/fastapi/client.browser";
import {
  linkTelegramApiService,
  type LinkTelegramFailureResponse,
  type LinkTelegramSuccessResponse,
} from "@/generated/fastapi";

export async function linkTelegram(
  accessToken: string,
): Promise<LinkTelegramSuccessResponse | LinkTelegramFailureResponse> {
  const response = await linkTelegramApiService({
    client: browserFastApiClient,
    auth: accessToken,
  });

  return response.data as LinkTelegramSuccessResponse | LinkTelegramFailureResponse;
}
